import { Block } from 'baseui/block';
// types
import { ISP_Puffer } from './types'
// components
import { ValuePanelIcon as TemperaturPanel } from '../../Devices/SensorAnalog'
// api
import { useGetObjectsChildrenQuery } from '../../../services/objects'
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';


export function SmallPanel(props: ISP_Puffer) {
    const { children: childElement } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const temperature = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const temperature1 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature1Sensor");
    const temperature2 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature2Sensor");
    const temperature3 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature3Sensor");
    const temperature4 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature4Sensor");
    const temperature5 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature5Sensor");
    const temperature6 = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature6Sensor");

    return (
        <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='5px'>
            {!temperature1 && temperature &&
                <TemperaturPanel key={temperature.id}  {...temperature}></TemperaturPanel>
            }
            {temperature1 &&
                <TemperaturPanel key={temperature1.id}  {...temperature1}></TemperaturPanel>
            }
            {temperature2 &&
                <TemperaturPanel key={temperature2.id}  {...temperature2}></TemperaturPanel>
            }
            {temperature3 &&
                <TemperaturPanel key={temperature3.id}  {...temperature3}></TemperaturPanel>
            }
            {temperature4 &&
                <TemperaturPanel key={temperature4.id}  {...temperature4}></TemperaturPanel>
            }
            {temperature5 &&
                <TemperaturPanel key={temperature5.id}  {...temperature5}></TemperaturPanel>
            }
            {temperature6 &&
                <TemperaturPanel key={temperature6.id}  {...temperature6}></TemperaturPanel>
            }
        </Block>
    );
}